import React, {useState, useEffect} from 'react'
import axios from 'axios'

export default function AdminAPI() {
    const [admin, setadmin] = useState([])
    const [callback, setCallback] = useState(false)

    useEffect(() =>{
        const getadmin = async () =>{
            const res = await axios.get('/api/admin')
            setadmin(res.data)
        }
        getadmin()
    },[callback])


    return {
        admin: [admin, setadmin],
        callback: [callback, setCallback],
    }
}
